import React, {useState} from 'react';
import './Home.css';
// import point from '../logos/point.jpg';
// import med from '../logos/med.png';
// import calendar from '../logos/calendar.png';
// import pin from '../logos/pin.png';
import ContactForm from '../components/ContactForm';
import contactDetails from '../logos/contact-details.png';
import addNotes from '../logos/add-notes.png';

const Home = () => {

  const testimonials = [
    "“Once again, Top Tier Benefits’ service was impeccable.” – R.H.",
    "“Your kindness and generosity is appreciated, and your customer service is top notch!” – R.S.",
    "“Your services are invaluable, and I don’t know what I would do without them – Many thanks!!!” – J.V.",
    "“Thank you for the Amazon.com Gift Card! I sincerely appreciate all your help and the incredible customer service!” – E.S.",
    "“It has been a pleasure working with you!” – M.S.",
    "“You are all amazing.” – N.J."
  ];

  const [current, setCurrent] = useState(0);

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="home-container">
      {/* Background Section */}
      <div className="background-section">
        <div className="text-container">
          <h3 className="headline">Welcome to Top Tier Benefits</h3>
          <h1 className="subheadline">
            Patient Care Comes First
          </h1>
        </div>
        {/* <div className="view-more">
          <ul className="horizontal-list">
            <img src={med} alt="Med Icon" className="med-icon" />
            <li>Find Your Product</li>
            <img src={point} alt="Point Icon" className="point-icon" />
            <img src={calendar} alt="Calendar Icon" className="calendar-icon" />
            <li>Place an Order</li>
            <img src={point} alt="Point Icon" className="point-icon" />
            <img src={pin} alt="Pin Icon" className="pin-icon" />
            <li>Receive Your Product</li>
            <li><a href="/how-it-works" className='view-button'>View More</a></li>
          </ul>
        </div> */}
      </div>

      {/* Four Boxes Section */}
      {/* <div className="boxes-container">
        <a href="/about" className="box" style={{ backgroundImage: `url(${require('../logos/ven-manage.png')})` }}>
          <h2 className="box-text">Vendor Management</h2>
        </a>

        <a href="/about" className="box" style={{ backgroundImage: `url(${require('../logos/train-ed.png')})` }}>
          <h2 className="box-text">Training & Education</h2>
        </a>

        <a href="/about" className="box" style={{ backgroundImage: `url(${require('../logos/experience-counts.png')})` }}>
          <h2 className="box-text">Experience Counts</h2>
        </a>

        <a href="/about" className="box" style={{ backgroundImage: `url(${require('../logos/data-analysis.png')})` }}>
          <h2 className="box-text">Data Analysis</h2>
        </a>
      </div> */}

      {/* Button Section */}
      {/* <div className="button-section">
        <a href="/about" className="about-button">
          See More
        </a>
      </div> */}

      {/* Content Section */}
      <div className="content-section">
        <div>
          <h1 className="content-header">
            GLOBAL LEADERS
          </h1>
          <p className="content-text">
            We are a global leader dedicated to revolutionizing benefit management networking and providing assistance to companies managing day to day operations of employee benefits programs.
          </p>
          <p className="content-text">
            We partner with insurers, employers, governments, and healthcare providers to optimize programs and enhance outcomes for millions of people.
          </p>
          <p className="content-text">
            Our low-cost model provides members, employees, and plan sponsors with low-cost and safe alternatives.
          </p>
          <p className="content-text">
            With over 20 years of experience, we are the industry's go-to resource.
          </p>
        </div>
      </div>

      {/* Trust Us Section */}
      {/* <div className="trust-section">
          <h1 className="trust-header">You Can Trust Us</h1>
        <div className="trust-items-container">
          <div className="trust-item">
            <img src={require('../logos/customer.png')} alt="Customer Icon" className="customer-icon" />
            <h3 className="trust-item-header">Customer First</h3>
            <p className="trust-info">Our staff will craft a personalized medication plan to suit your needs and preferences.</p>
          </div>
          <div className="trust-item">
            <img src={require('../logos/price-match.png')} alt="Price Icon" className="price-icon" />
            <h3 className="trust-item-header">Prices Match</h3>
            <p className="trust-info">We price match for affordability (with a Canadian pharmacy).</p>
          </div>
          <div className="trust-item">
            <img src={require('../logos/info-security.png')} alt="Info Icon" className="security-icon" />
            <h3 className="trust-item-header">Information Security</h3>
            <p className="trust-info">Your info is secure with top online encryption.</p>
          </div>
        </div>
        <img src={require('../logos/personalized-experience.png')} alt="Experience Banner" className="experience-banner" />
      </div> */}
      <div className="trust-section">
          <h1 className="trust-header">How It Works</h1>
          <h2 className="trust-header-h2">Top Tier Benefits is a benefit optimizer. When employees save on the medicine they need, their company saves too.</h2>
        <div className="trust-items-container">
          <div className="trust-item">
            <img src={require('../logos/1.png')} alt="Customer Icon" className="customer-icon" />
            <h3 className="trust-item-header">First Step</h3>
            <p className="trust-info">Introduce the Program to your Employees</p>
          </div>
          <div className="trust-item">
            <img src={require('../logos/2.png')} alt="Price Icon" className="price-icon" />
            <h3 className="trust-item-header">Second Step</h3>
            <p className="trust-info">We Create your New Account</p>
          </div>
          <div className="trust-item">
            <img src={require('../logos/3.png')} alt="Info Icon" className="security-icon" />
            <h3 className="trust-item-header">Third Step</h3>
            <p className="trust-info">Employees Order their RX</p>
          </div>
        </div>
        <img src={require('../logos/personalized-experience.png')} alt="Experience Banner" className="experience-banner" />
      </div>

      {/* How It Works Section */}
      {/* <div className="how-section">
        <h2 className="how-header">How It Works</h2>
        <p className="how-subheader">Top Tier Benefits is a benefit optimizer. When employees save on the medicine they need, their company saves too.</p>
        <div className="s-container">
          <div className="s">
            <div className="s-circle">1</div>
            <p>Introduce the Program to your Employees</p>
          </div>
          <div className="s-line"></div>
          <div className="s">
            <div className="s-circle">2</div>
            <p>We Create your New Account</p>
          </div>
          <div className="s-line"></div>
          <div className="s">
            <div className="s-circle">3</div>
            <p>Employees Order their RX</p>
          </div>
        </div>
      </div> */}

      {/* Customer Testimonial Section */}
      <div className="testimonial-section">
        <div className="testimonial-left">
          <h2 className="testimonial-header">What our customers are saying about us?</h2>
          <p>5 Million+ prescriptions filled for our happy customers</p>

          <div className="testimonial-slider">
            <button className="arrow left-arrow" onClick={handlePrev}>‹</button>
            <p className="testimonial-quote">{testimonials[current]}</p>
            <button className="arrow right-arrow" onClick={handleNext}>›</button>
          </div>
        </div>
      </div>


      {/* Appointment Section */}
        <div className="appointment-container">
          {/* Left Content */}
          <div className="appointment-left">
            <h1 className="appointment-header">Contact Us Today!</h1>
            <div className="appointment-info">
              <div className="info-item">
              <img src={contactDetails} alt="Contact Details" className="details-icon" />
                <div>
                  <h3 className='appointment-subheader'>Contact Details</h3>
                  <p className='appointment-text'>Enter your full name, email, and phone number to confirm your appointment and receive updates.</p>
                </div>
              </div>
              <div className="info-item">
              <img src={addNotes} alt="Additional Notes" className="notes-icon" />
                <div>
                  <h3 className='appointment-subheader'>Additional Notes</h3>
                  <p className='appointment-text'>Include any additional information to help us better assist you.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content: Form */}
          <div className="appointment-right">
            <ContactForm /> {/* Reusable ContactForm */}
          </div>
        </div>

    </div>
  );
};

export default Home;